import { Component, DoCheck, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { PathRegistration } from '../../user/path-registration.model'
import { AppState } from '../../app.service'
import { Path } from '../../path/path-v2.model'
import { User } from '../../user/user.model'
import { CordovaService } from '../../cordova.service'
import { UserService } from '../../user/user.service'
import { NotificationService } from '../../notification/notification.service'
import { ToastrService } from 'ngx-toastr'
import { I18n } from '../../i18n.service'
import { AlertNotifyComponent } from '../../alert-notify/alert-notify.component';
import { MatDialog } from '@angular/material/dialog';
import { ToasterService } from 'src/app/toaster.service';
import { ModalController, Platform } from '@ionic/angular';


import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { SpinnerService } from 'src/app/spinner.service';
import { SessionService } from 'src/app/session/session.service';
import mixpanel from 'mixpanel-browser';
import { HomeUiService } from 'src/app/new-design/home-ui.service';
import { DayPartSelectComponent } from 'src/app/day-part-select/day-part-select.component';
import { AnimationsService } from 'src/app/shared/animations.service';
import { MyCommitmentsComponent } from 'src/app/my-commitments/my-commitments.component';
import { MobileChatBoardComponent } from '../mobile-chat-board/mobile-chat-board.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export interface CurrentPathRegistration {
  [pathRegistration: string]: any;
}
export interface UpdatePathRegistration {
  [updatePathRegistration: string]: any;
}

@Component({
  selector: 'app-notifications-settings',
  templateUrl: './notifications-settings.component.html',
  styleUrls: ['./notifications-settings.component.scss']
})
export class NotificationsSettingsComponent implements OnInit, DoCheck, OnDestroy {
  pushNotificationsEnabled: boolean
  confirmedTime: string
  selectedTimeOption: string
  currentPath: Path
  currentUser: User
  loading: boolean = false
  isTimePicked=false
  isChanged = false
  emailReminderEnabled: boolean
  pushReminderEnabled: boolean
  socialReminderEnabled: boolean
  socialEmailReminder: boolean

  isLearningInfo: boolean = false
  isSocialInfo: boolean = false
  isMobileWebIos = false;
  isMobileWeb=false;

  @Input()selectedTime: any
  selectedSocialTime: any
  learningTime: any
  isMobile: boolean
  public pathRegistration: CurrentPathRegistration;
  public updatePathRegistration: UpdatePathRegistration;
  isSubReply: boolean
  processedCommitmentNotifications: Set<number> = new Set();
  processedCommunityNotifications: Set<number> = new Set();
  destroyed$ = new Subject<boolean>();
  constructor(
    private i18n: I18n,
    private appState: AppState,
    private cordovaService: CordovaService,
    private userService: UserService,
    private dialog: MatDialog,
     private platform: Platform,
    private modalController: ModalController,
    private firebaseX: FirebaseX,
    private router: Router,
    private spinnerService: SpinnerService,
    private toastrService: ToasterService,
    private homeUIService: HomeUiService,
    public route: ActivatedRoute,
    private ngZone: NgZone,
    private animationService: AnimationsService,
    private sessionService: SessionService) {
    this.currentUser = this.appState.get('currentUser')
    this.currentPath = this.appState.get('currentPath')
    this.pathRegistration = this.appState.get('pathRegistration')
    console.log('pathRegistration :', this.pathRegistration);
    this.isMobile = this.appState.get('isMobile')

    let learningTime = localStorage.getItem('learningTime')
    if (learningTime) {
      mixpanel.track('Learning Reminder', {'learnTime': learningTime})
      this.learningTime = learningTime
    }else{
      if (this.pathRegistration && this.pathRegistration.pathData) {
        this.learningTime = this.pathRegistration.pathData.loginReminderTime
      } 
    }
    
    if (this.pathRegistration && this.pathRegistration.pathData) {
      if (this.pathRegistration.pathData.loginReminderEnabled) {
        this.pushNotificationsEnabled = this.pathRegistration.pathData.loginReminderEnabled
      }
      if (this.pathRegistration.pathData.emailReminderEnabled) {
        this.emailReminderEnabled = this.pathRegistration.pathData.emailReminderEnabled
      }
      if (localStorage.getItem('pushReminderEnabled')) {
        this.pushReminderEnabled = true
      }
      if (this.pathRegistration.pathData.socialReminderEnabled) {
        this.socialReminderEnabled = this.pathRegistration.pathData.socialReminderEnabled
      }
      if (this.pathRegistration.pathData.socialEmailEnabled) {
        this.socialEmailReminder = this.pathRegistration.pathData.socialEmailEnabled
      }
    }

  }

  ngOnInit() {
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb);
    setTimeout(()=>{
      this.selectedSocialTime  = this.selectedTime;
    },100);
  }

  ngOnChanges(){
    console.log("changes done");
  }
  prevScreen() {
    this.modalController.dismiss();
    //window.history.back();
  }
  ngDoCheck(){
    this.isSubReply = this.appState.get('isSubReply')
    let learningTime = localStorage.getItem('learningTime')
    if (learningTime) {
      this.learningTime = learningTime
    }else{
      if (this.pathRegistration && this.pathRegistration.pathData) {
        this.learningTime = this.pathRegistration.pathData.loginReminderTime
      } 
    }
  }

  async toggle(){
    mixpanel.track('Learning Reminder', {'push notification': this.pushNotificationsEnabled})

    if (this.pushNotificationsEnabled && this.cordovaService.isIOS()) {
        this.notificationAlertBox()
    }
    if (this.pushNotificationsEnabled && this.platform.is('android')) {
      const granted = await this.ensureAndroidPushPermission();
      if (!granted) {
        this.toastrService.error(this.i18n.t('Please allow notifications for this app in your device settings'));
      }
    }
    this.save()
  }

  async socialToggle() {
    if (this.socialReminderEnabled && this.platform.is('android')) {
      const granted = await this.ensureAndroidPushPermission();
      if (!granted) {
        this.toastrService.error(this.i18n.t('Please allow notifications for this app in your device settings'));
      }
    }
    this.save()
  }

  // Android 13+ needs the POST_NOTIFICATIONS runtime grant; without it FCM delivers
  // the message but the OS never shows it. grantPermission() never resolves when the
  // runtime grant exists but notifications are blocked in system settings, hence the timeout.
  private async ensureAndroidPushPermission(): Promise<boolean> {
    try {
      await this.platform.ready();
      if (await this.firebaseX.hasPermission()) {
        return true;
      }
      await Promise.race([
        this.firebaseX.grantPermission(),
        new Promise(resolve => setTimeout(resolve, 30000))
      ]);
      const granted = await this.firebaseX.hasPermission();
      mixpanel.track('Android push permission after toggle', { granted });
      return granted;
    } catch (error) {
      console.error('Error requesting push permission', error);
      return false;
    }
  }

  // Fetch the current FCM token before saving so the server never gets a stale or
  // empty deviceRegistrationId (previously save() read localStorage before getToken() resolved).
  private async refreshDeviceToken() {
    if (!(this.platform.is('ios') || this.platform.is('android'))) {
      return;
    }
    try {
      await this.platform.ready();
      const token = await this.firebaseX.getToken();
      if (token) {
        localStorage.setItem('deviceToken', token);
      }
    } catch (error) {
      console.error('Error getting token', error);
    }
  }

  async save() {
    // this.setLocalData()
    if (this.isMobile) {
      await this.refreshDeviceToken();
    }
    mixpanel.track('Learning Reminder', {'email notification': this.emailReminderEnabled})
    mixpanel.track('Social Notification', {'email notification': this.socialEmailReminder, 'push notification': this.socialReminderEnabled})
    let deviceId;
    if (this.isMobile && (localStorage.getItem('deviceToken') !== null || localStorage.getItem('deviceToken') != undefined)) {
      deviceId =localStorage.getItem('deviceToken')
    }
    else {
      deviceId = this.pathRegistration.pathData.deviceRegistrationId;
    }
    const pathRegistration = new PathRegistration({
      userId: this.currentUser.id,
      pathId: this.currentPath.id,
      pathData: {
        loginReminderEnabled: this.pushNotificationsEnabled,
        loginReminderTime: this.confirmedTime,
        deviceRegistrationId: deviceId,
        emailReminderEnabled: this.emailReminderEnabled,
        pushReminderEnabled: this.pushReminderEnabled,
        socialReminderEnabled: this.socialReminderEnabled,
        socialEmailEnabled: this.socialEmailReminder
      }
    })

    this.getToken()

    this.loading = true
    const deviceToken = localStorage.getItem('deviceToken')
    console.log('deviceToken', deviceToken);
    console.log('deviceRegistrationId', this.pathRegistration.pathData.deviceRegistrationId);
    if(this.isMobile) {
      if (deviceToken || this.pathRegistration.pathData.deviceRegistrationId) {
       this.updateNotificationToggles(pathRegistration);
      } else {
        this.spinnerService.off()
        console.error('Device token not found')
        this.loading = false
        if (this.isMobile) {
          this.getToken()
          this.toastrService.error(this.i18n.t('Device token not found'))
        }
        
      }
    }
    else {
      this.updateNotificationToggles(pathRegistration);
    }
     
  }

  updateNotificationToggles(pathRegistration){
    this.spinnerService.on()
    this.userService.savePathRegistration(pathRegistration).subscribe(
      (response) => {
        console.log("Notifications reponse ",response);
        this.updatePathRegistration = response.data
        this.appState.set("pathRegistration", this.updatePathRegistration.updatePathRegistration);
        this.toastrService.success(this.i18n.t('Settings updated!'))
      },
      error => {
        this.spinnerService.off()
        console.log('Server error', error)
        this.loading = false
        this.toastrService.error(this.i18n.t('Settings not saved. Please check your internet connection.'))
      },
      () => {
        this.spinnerService.off()
        this.loading = false
      }
    )
  }
  refresh() {
    this.appState.refreshMainComponent.emit();
    this.spinnerService.off()
  }


  notificationAlertBox(){
    let dialogRef = this.dialog.open(AlertNotifyComponent)

    dialogRef.afterClosed().subscribe((result) => {

    })
  }
  loadprocessedCommitmentNotifications() {
    const storedData = localStorage.getItem('processedCommitmentNotifications');
    if (storedData) {
      this.processedCommitmentNotifications = new Set(JSON.parse(storedData));
    }
  }
  loadprocessedCommunityNotifications() {
    const storedData = localStorage.getItem('processedCommunityNotifications');
    if (storedData) {
      this.processedCommunityNotifications = new Set(JSON.parse(storedData));
    }
  }
  getToken(){
    console.log('isSubReply', this.appState.get('isSubReply'));
    
    if (this.platform.is('ios') || this.platform.is('android')) {

      this.platform.ready().then(() => {

        
        this.firebaseX.hasPermission().then((res)=> {
          console.log('res :', res);
          if (res === false) {
            this.firebaseX.grantPermission().then((permission) => {
              console.log("ios permission : ", permission);
            });

            this.firebaseX
              .getToken()
              .then((token) => {
                localStorage.setItem("deviceToken", token);
                console.log(`The token is ${token}`);
              })
              .catch((error) => console.error("Error getting token", error));
          }else{
            this.firebaseX
            .onMessageReceived()
              .subscribe((data) => {
               let postData = JSON.parse(data?.keysandvalues)
              console.log('data outside platform.resume() app component:', data);
                let notificationId = data['gcm.message_id']?parseInt(data['gcm.message_id']):parseInt(data['google.message_id']?.split(':')[1]?.split('%')[0])
              console.log('Starting notification ID (app component):', notificationId);
                const isForeground = data.tap === 'foreground' ||
                  ((postData['notification_foreground'] === true || data['notification_foreground'] === 'true') && !data.tap);
                const isTappedFromBg = !isForeground && !!data.tap;
                  const requestData = {
                  userId: postData.user_id,
                  mode: postData?.mode,
                  postId: postData?.post_id,
                  id: notificationId,
                  route: postData?.route,
                     body: data?.aps?data?.aps?.alert?.body: data?.body,
                    title: data?.aps? data?.aps?.alert?.title : data?.title,
                  pathId: postData?.path_id,
                  postData: JSON.parse(data?.keysandvalues),
                  notification_type: postData?.notification_type,
                    notificationSentTimestamp: data?.sent_at,
                   tap: data?.tap,
                   screenContentId: postData?.screenContentId,
                   receivedInForeground: isForeground
                };
                this.loadprocessedCommitmentNotifications();
                this.loadprocessedCommunityNotifications();
                if (!this.isCommitmentNotificationProcessed(notificationId) && !this.processedCommunityNotifications?.has(notificationId)) {
                  mixpanel.track('Push notification received in notificationSettingsComponent', {
                    userId: postData.user_id,
                       body: data?.aps?data?.aps?.alert?.body: data?.body,
                    title: data?.aps? data?.aps?.alert?.title : data?.title,
                  pathId: postData?.path_id,
                    id: notificationId,
                    notification_type: postData?.notification_type,
                    postData: JSON.parse(data?.keysandvalues),
                    notificationSentTimestamp: data?.sent_at,
                    currentTimestamp: new Date().toISOString(),
                     tap: data?.tap,
                     screenContentId: postData?.screenContentId,
                     receivedInForeground: isForeground
                  });
                }
            // "AfterAppInit" used for when app is not in BG
              this.appState.set('AfterAppInit', requestData)

               if (isTappedFromBg && !!this.appState.get('currentUser')) {
                  // Cases 1 & 2: User tapped notification banner while app was running in BG.
                  // Session is already active (currentUser set), so route directly.
                  // platform.resume fires before onMessageReceived in tap scenarios,
                  // so we route directly here instead of waiting for resume.
                  mixpanel.track('Banner tapped from BG - routing directly in notification settings screen', { id: notificationId, tap: data?.tap });
                  this.ngZone.run(() => {
                    setTimeout(() => {
                      this.handleNotificationRoute(postData, notificationId, requestData, data);
                    }, 500);
                  });

                } else if (isTappedFromBg && !this.appState.get('currentUser')) {
                  // Case 3: App was killed. Session not loaded yet (currentUser is null).
                  // AfterAppInit is stored above; routeAfterNotification in session.service
                  // will handle routing after the session is fully initialized.
                  mixpanel.track('Banner tapped, app killed - waiting for session init in notification settings screen', { id: notificationId });

                } else if (isForeground) {
                  // Case 4: Notification arrived while app was in foreground.
                  // Never redirect — not now, not after any BG/FG cycle.
                  // We intentionally skip setting up platform.resume so this is permanent.
                  mixpanel.track('FG notification received, no redirect in notificatio settings', { id: notificationId, tap: data?.tap });

                } else {
                  // BG silent delivery — user will open the app manually later.
                  // Set up platform.resume to route at that point.
                  mixpanel.track('BG notification, waiting for resume in notificatio settings screen', { id: notificationId, tap: data?.tap });
                  this.platform.resume.pipe(takeUntil(this.destroyed$)).subscribe(() => {
                    mixpanel.track('Platform resume in notification settings Component');
                    this.loadprocessedCommitmentNotifications();
                    this.loadprocessedCommunityNotifications();
                    let communitySavedId = parseInt(localStorage.getItem('CommunityNotificationId'))
                    let commitmentsSavedId = parseInt(localStorage.getItem('CommitmentsNotificationId'))
                    this.handleNotificationRoute(postData, notificationId, requestData, data);
                  });
                }
                this.sessionService.removeNotificationBadge()
              
            },
            (error) => {
              console.log('error notifications:', error);
            });
          }
          
          
        })


        this.firebaseX.onTokenRefresh().subscribe((token: string) => {
          localStorage.setItem("deviceToken", token);
          console.log("New device token : ", token);
        });
      }).catch(error => {
        console.log("platform  error : ", error);
      });

    }
  }

   private handleNotificationRoute(postData, notificationId, requestData, data) {
    this.loadprocessedCommitmentNotifications();
    this.loadprocessedCommunityNotifications();
    const notificationData = {
      userId: postData.user_id,
      body: data?.aps ? data?.aps?.alert?.body : data?.body,
      title: data?.aps ? data?.aps?.alert?.title : data?.title,
      pathId: postData?.path_id,
      id: notificationId,
      notification_type: postData?.notification_type,
      postData: JSON.parse(data?.keysandvalues),
      notificationSentTimestamp: data?.sent_at,
      notificationOpenedTimestamp: new Date().toISOString(),
      tap: data?.tap,
      screenContentId: postData?.screenContentId
    };

    if (postData.route.match('/main/commitments') && notificationId
        && !this.isCommitmentNotificationProcessed(notificationId)
        && !this.processedCommunityNotifications?.has(notificationId)) {
      this.processedCommitmentNotifications.add(notificationId);
      mixpanel.track('Habit commitment push notification is opened in notification settings', notificationData);
      localStorage.setItem('CommitmentsNotificationId', notificationId.toString());
      if (this.homeUIService.getModalStack()?.length > 0) {
        if (this.homeUIService.getModalStack()[this.homeUIService.getModalStack()?.length - 1]?.component?.name != 'MyCommitmentsComponent'
            && this.homeUIService.getModalStack()[this.homeUIService.getModalStack()?.length - 1]?.name != 'MyCommitmentsComponent') {
          this.homeUIService.setModalStack(MyCommitmentsComponent);
          this.homeUIService.openNextComponent(MyCommitmentsComponent);
        }
      } else {
        this.homeUIService.setModalStack(MyCommitmentsComponent);
        this.homeUIService.openNextComponent(MyCommitmentsComponent);
      }
      localStorage.setItem('processedCommitmentNotifications', JSON.stringify(Array.from(new Set(this.processedCommitmentNotifications))));
    }

    if (postData.route.match('/main/questions') && notificationId
        && !this.isCommitmentNotificationProcessed(notificationId)
        && !this.processedCommunityNotifications?.has(notificationId)) {
      this.processedCommunityNotifications.add(notificationId);
      mixpanel.track('Community push notification is opened in notification settings', notificationData);
      this.appState.set('communityNotification', true);
      this.appState.set('notificationData', requestData);
      if (this.homeUIService.getModalStack()?.length > 0) {
        if (this.homeUIService.getModalStack()[this.homeUIService.getModalStack()?.length - 1]?.component?.name == 'MobileChatBoardComponent'
            || this.homeUIService.getModalStack()[this.homeUIService.getModalStack()?.length - 1]?.name == 'MobileChatBoardComponent') {
          this.appState.set('isBackground', true);
        } else {
          this.homeUIService.setModalStack(MobileChatBoardComponent);
          this.homeUIService.openNextComponent(MobileChatBoardComponent);
        }
      } else {
        this.homeUIService.setModalStack(MobileChatBoardComponent);
        this.homeUIService.openNextComponent(MobileChatBoardComponent);
      }
      localStorage.setItem('processedCommunityNotifications', JSON.stringify(Array.from(new Set(this.processedCommunityNotifications))));
    }
  }
  isCommitmentNotificationProcessed(id: number): boolean {
    console.log("this.processedCommitmentNotifications?.has(id)",this.processedCommitmentNotifications?.has(id),id)
    return this.processedCommitmentNotifications?.has(id);
  }
  async openComp() {
    // modal = this.homeUIService.openNextComponent(DayPartSelectComponent)
    const modal = await this.modalController.create({
      component: DayPartSelectComponent,
      cssClass: 'custom-modal',
      enterAnimation: this.animationService.slideInLeftEnterAnimation,
      leaveAnimation: this.animationService.SlideOutRightLeaveAnimation
    });
     await modal.present() 
     this.homeUIService.setModalStack(modal)
    modal.onDidDismiss().then((val) => {
      this.selectedTime = val.data?.selectedTime;
      })
  }

  close(){
    this.modalController.dismiss();
  }

  changeTime(){
    this.homeUIService.openNextComponent(DayPartSelectComponent,'','desktop-profile-custom')
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
